<script lang="ts" setup>
import TSkeleton from '../TSkeleton.vue';

const props = withDefaults(
  defineProps<{
    lines?: number;
    size?: 'small' | 'medium' | 'large';
    space?: 'small' | 'medium' | 'large';
    pattern?: 'uniform' | 'varied';
  }>(),
  {
    lines: 3,
    size: 'medium',
    space: 'small',
    pattern: 'varied',
  },
);

const ALTERNATING_PATTERN_DIVISOR = 2;

const getWidth = (index: number): 'full' | 'half' => {
  if (props.pattern === 'uniform') {
    return 'full';
  }
  // Varied pattern: alternate between full and half, with last line often being half
  if (index === props.lines) {
    return 'half';
  }
  return index % ALTERNATING_PATTERN_DIVISOR === 0 ? 'half' : 'full';
};
</script>

<template>
  <div class="w-full">
    <TSkeleton
      v-for="index in lines"
      :key="index"
      :width="getWidth(index)"
      :size="size"
      :space="space"
    />
  </div>
</template>
